import { render, staticRenderFns } from "./rest_evrasia.vue?vue&type=template&id=c47ba776&scoped=true&"
import script from "./rest_evrasia.vue?vue&type=script&lang=js&"
export * from "./rest_evrasia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47ba776",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c47ba776')) {
      api.createRecord('c47ba776', component.options)
    } else {
      api.reload('c47ba776', component.options)
    }
    module.hot.accept("./rest_evrasia.vue?vue&type=template&id=c47ba776&scoped=true&", function () {
      api.rerender('c47ba776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/item/tabs/evrasia/rest_evrasia.vue"
export default component.exports